<div class="site-header">

    <div *ngIf="layout === 'classic'" class="site-header__middle container">
        <div class="site-header__logo">
        </div>
        <div class="site-header__search">
            <app-search location="header"></app-search>
        </div>
        <div class="site-header__phone">
            <div class="site-header__phone-title">Customer Service</div>
            <div class="site-header__phone-number">{{ store.primaryPhone }}</div>
        </div>
    </div>
    <div class="temp">
        <div class="temp">

        </div>
    </div>
    <div class="navbar p-2">
        <div class="navbar-left">
            <img class="down-up cursor-pointer" src="../../../assets/Home-Connect/Home Connect Main_logo 1.svg"
                height="50px" style="width: 162px;">
        </div>
        <div class="navbar-center">

        </div>
        <div class="navbar-right">
            <div *ngIf="!this.sharedDataService.getValue('addressChangedata') && (currentUrl === '/checkcoverage/packages') &&
                [configuration.Frogfoot,configuration.Vumatel,configuration.MetroFibreNetworx, configuration.Openserve,configuration.Balwin,
                configuration.Netstream,configuration.CenturyCityConnect,configuration.WaterfallView,configuration.Octotel,configuration.DNATel,configuration.LinkLayer,configuration.WaterfallAccessNetworks
                ].includes(activeUserStorage.getValue('serviceProviderId'))" class="ping" matTooltip='Info'
                matTooltipPosition="below" matTooltipClass="sidebar_tooltip" (click)="toggleDrawer()">i</div>

            <img matTooltip='Check Coverage' matTooltipPosition="below" class="down-up cursor-pointer mr-3"
                matTooltipClass="sidebar_tooltip" (click)="checkCoverage()"
                style="filter: invert(50%) brightness(200%);"
                src="../../../../assets/images/providersImg/Artboard 1 copy 4.svg" height="36px">

            <button class="btn btn-light sign-inn" matButton (click)="signin()" *ngIf="!isLoggedIn && currentUrl == '/networkstatus'">Portal Sign In</button>

            <!-- <i class="fa-solid fa-bell" style="color: #B197FC;"></i> -->

            <app-indicator class="mr-3" *ngIf="!personIcon() && !userImage && currentUrl != '/networkstatus'"
                link="./account" icon="person-20" trigger="click" #accountIndicator="appIndicator">
                <app-account-menu (closeMenu)="accountIndicator.close(true)"></app-account-menu>
            </app-indicator>

            <app-indicator class="mr-3" *ngIf="personIcon() || userImage && currentUrl != '/networkstatus'"
                link="./account" icon="person-image" trigger="click" #accountIndicator="appIndicator">
                <app-account-menu (closeMenu)="accountIndicator.close(true)"></app-account-menu>
            </app-indicator>
        </div>
    </div>
    <div class="navbar" style="background: white;">
        <div class="navbar-center">
            <app-header-links class="nav-panel__nav-links nav-links"></app-header-links>
        </div>
    </div>
</div>